import { render, staticRenderFns } from "./VtBreadCrumbs.vue?vue&type=template&id=9085a4ea&scoped=true&"
import script from "./VtBreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./VtBreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./VtBreadCrumbs.vue?vue&type=style&index=0&id=9085a4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9085a4ea",
  null
  
)

export default component.exports